import { Dispatch, SetStateAction } from 'react'
import { ValidationError } from 'yup'
import { getErrorsForFields } from './getErrorsForField'
import { ActionFailedEventDetail, setCustomValidityForFields } from '../../../../../../MyStichtingOpenHelpers/src/static'

/**
 * @description
 * takes the Event object from a ACTION_FAILED event and repopulates the errors array
 * if there are errors related to this fieldName
 * @memberof ValidationMessage
 * */
export const onActionFailed = (
    event: CustomEvent<ActionFailedEventDetail>,
    formId: string,
    fieldNames: string | string[],
    setValidationErrors: Dispatch<SetStateAction<ValidationError[]>>,
) => {
    if (formId !== event.detail.formId) {
        return
    }

    const errors = getErrorsForFields(event.detail.error.validationErrors ?? [], fieldNames)

    setValidationErrors(errors)
    const form = document.getElementById(formId) as HTMLFormElement | null
    if (form) setCustomValidityForFields(Array.isArray(fieldNames) ? fieldNames : [fieldNames], form, errors)
}
